/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { empty, isArray, prepareResponseData } from "../../Utilities/utils";

// css
import "../schools/Schools.css";

// api
import schoolApi from "../../api/School";
import subscriptionApi from "../../api/Subscription";

// data
import { yesNo } from "../../data/yesNo";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import InputField from "../../components/form/InputField";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import SelectField from "../../components/form/SelectField";
import EmptyDiv from "../../components/emptyDiv/EmptyDiv";
import { Toast } from "primereact/toast";
import { NigeriaStatesAndLGA } from "../../data/NigeriaStatesAndLGA";
import FullPageLoader from "../../components/loader/FullPageLoader";
import FormSubHeader from "../../components/form/FormSubHeader";
import colors from "../../config/colors";

const required = "This field is required.";
const validationSchema = Yup.object().shape({
  name: Yup.string().required(required),
  active: Yup.string().required(required),
  address: Yup.string().min(5).max(100).required(required),
  email: Yup.string().email("Invalid email").required(required),
  govt_approved: Yup.string().min(2).max(3).required(required),
  state_of_origin: Yup.string().min(2).max(30).required(required),
  lga_of_origin: Yup.string().min(2).max(30).required(required),
  state_of_residence: Yup.string().min(2).max(30).required(required),
  country: Yup.string().min(2).max(30).required(required),
  lga_of_residence: Yup.string().min(2).max(30).required(required),
  phone_number1: Yup.string().min(2).max(15).required(required),
  phone_number2: Yup.string().min(2).max(15).optional(),
  owner_phone: Yup.string().min(2).max(15).required(required),
  owner_name: Yup.string().min(2).max(30).required(required),
  owner_address: Yup.string().min(2).max(30).required(required),
  owner_email: Yup.string().email("Invalid email").required(required),
  subscription_package_id: Yup.string().required(required),
});

const AddUpdateSchool = ({ ...props }) => {
  const navigate = useNavigate();
  const getValues = useParams();
  const schoolId =
    !empty(getValues) && !empty(getValues.schoolId) ? getValues.schoolId : "";
  const [isLoading, setIsLoading] = useState(false);
  const toastTR = useRef(null);
  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    govt_approved: "",
    address: "",
    state: "",
    lga: "",
    phone_number1: "",
    phone_number2: "",
    owner_name: "",
    owner_address: "",
    owner_email: "",
    owner_phone: "",
    country: "",
    subscription_package_id: "",
  });
  const [selectedStateLGA, setSelectedStateLGA] = useState([]);
  const [selectedStateLGAResidence, setSelectedStateLGAResidence] = useState(
    [],
  );
  const [subscriptionPackages, setSubscriptionPackages] = useState([]);

  useEffect(() => {
    getSubscriptionPackages();
  }, []);

  useEffect(() => {
    if (schoolId) {
      getSchoolDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR.current.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  const getSubscriptionPackages = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const response = await subscriptionApi.getSubscriptionPackages();
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.response) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to fetch subscription packages.",
        );
      }

      setSubscriptionPackages(
        isArray(response_data.response) ? response_data.response : [],
      );
    } catch (error) {
      responseDialog("error", "Error Alert", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get School details
   * @returns
   */
  const getSchoolDetails = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const response = await schoolApi.getSingleSchool(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.response) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to fetch school details",
        );
      }

      if (!empty(response_data) && !empty(response_data.response)) {
        const schoolData = response_data.response;
        setInitialValues({
          name: !empty(schoolData.name) ? schoolData.name : "",
          email: !empty(schoolData.email) ? schoolData.email : "",
          address: !empty(schoolData.address) ? schoolData.address : "",
          state_of_residence: !empty(schoolData.stateOfResidence)
            ? schoolData.stateOfResidence
            : "",
          lga_of_residence: !empty(schoolData.lgaOfResidence)
            ? schoolData.lgaOfResidence
            : "",
          state_of_origin: !empty(schoolData.stateOfOrigin)
            ? schoolData.stateOfOrigin
            : "",
          lga_of_origin: !empty(schoolData.lgaOfOrigin)
            ? schoolData.lgaOfOrigin
            : "",
          country: !empty(schoolData.country) ? schoolData.country : "",
          phone_number1: !empty(schoolData.phoneNumber1)
            ? schoolData.phoneNumber1
            : "",
          phone_number2: !empty(schoolData.phoneNumber2)
            ? schoolData.phoneNumber2
            : "",
          owner_phone: !empty(schoolData.ownerPhone)
            ? schoolData.ownerPhone
            : "",
          owner_name: !empty(schoolData.ownerName) ? schoolData.ownerName : "",
          owner_email: !empty(schoolData.ownerEmail)
            ? schoolData.ownerEmail
            : "",
          owner_address: !empty(schoolData.ownerAddress)
            ? schoolData.ownerAddress
            : "",
          govt_approved: !empty(schoolData.govtApproved)
            ? schoolData.govtApproved
            : "",
          subscription_package_id: !empty(schoolData.subscriptionPackageId)
            ? schoolData.subscriptionPackageId
            : "",
          active:
            !empty(schoolData.active) && schoolData.active === true
              ? "Yes"
              : "No",
        });

        const stateOfOrigin = !empty(schoolData.stateOfOrigin)
          ? schoolData.stateOfOrigin
          : "";
        const stateOfResidence = !empty(schoolData.stateOfResidence)
          ? schoolData.stateOfResidence
          : "";
        const stateOfOriginLGAs =
          NigeriaStatesAndLGA.find(
            (stateObj) =>
              !empty(stateObj) &&
              !empty(stateObj.title) &&
              stateObj.title === stateOfOrigin,
          )?.lgas || [];
        setSelectedStateLGA(stateOfOriginLGAs);
        const stateOfResidenceLGAs =
          NigeriaStatesAndLGA.find(
            (stateObj) =>
              !empty(stateObj) &&
              !empty(stateObj.title) &&
              stateObj.title === stateOfResidence,
          )?.lgas || [];
        setSelectedStateLGAResidence(stateOfResidenceLGAs);
      }
    } catch (error) {
      responseDialog("error", "Error Alert", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    if (!isLoading) setIsLoading(true);
    try {
      const fields = [
        "name",
        "email",
        "govt_approved",
        "address",
        "state_of_origin",
        "lga_of_origin",
        "state_of_residence",
        "lga_of_residence",
        "phone_number1",
        "phone_number2",
        "owner_name",
        "owner_address",
        "owner_email",
        "owner_phone",
        "country",
        "active",
        "subscription_package_id",
      ];
      const schoolDetails = {};
      if (!empty(values)) {
        _.forEach(fields, (data) => {
          schoolDetails[data] =
            !empty(data) && !empty(values[data]) ? values[data] : "";
        });
      }
      let response;
      let schoolAdded = false;
      let schoolUpdated = false;
      if (!schoolId) {
        response = await schoolApi.addSchool(schoolDetails);
        schoolAdded = true;
      } else {
        response = await schoolApi.updateSchool(schoolId, schoolDetails);
        schoolUpdated = true;
      }

      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        if (
          !empty(response_data) &&
          !empty(response_data.statusCodeType) &&
          response_data.statusCodeType === "unauthorized"
        ) {
          return navigate("/");
        }
        const error_response = !empty(response_data.response)
          ? response_data.response
          : "Something went wrong!";
        return responseDialog("error", "Error Alert!", error_response);
      }

      const data =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {};
      let _schoolId = "";
      if (!empty(data)) {
        _schoolId = !empty(data.schoolId) ? data.schoolId : "";
        return navigate(`/school/${_schoolId}/profile`, {
          state: {
            schoolAdded,
            schoolUpdated,
          },
        });
      }

      navigate(`/schools`, {
        state: { schoolAdded, schoolUpdated },
      });
    } catch (error) {
      return responseDialog(
        "error",
        "Internal Error!",
        "Something went wrong.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleStateOfOriginChange = (setFieldValue) => (e) => {
    const selectedState = e.target.value;
    const lgas =
      NigeriaStatesAndLGA.find(
        (stateObj) =>
          !empty(stateObj) &&
          !empty(stateObj.title) &&
          stateObj.title === selectedState,
      )?.lgas || [];
    setFieldValue("state_of_origin", selectedState);
    setSelectedStateLGA(lgas);
  };

  const handleStateOfResidenceChange = (setFieldValue) => (e) => {
    const selectedState = e.target.value;
    const lgas =
      NigeriaStatesAndLGA.find(
        (stateObj) =>
          !empty(stateObj) &&
          !empty(stateObj.title) &&
          stateObj.title === selectedState,
      )?.lgas || [];
    setFieldValue("state_of_residence", selectedState);
    setSelectedStateLGAResidence(lgas);
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            {/*  header start */}
            <MainHeader title="Add School" />
            {/* end of header */}

            <div className="form-container mt-30">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, handleChange, setFieldValue }) => (
                  <Form style={{ width: "100%" }}>
                    <div>
                      <em>
                        <strong>Note: *</strong> Please enter the correct
                        details for the school
                      </em>
                    </div>
                    <FormSubHeader title="School Details" />
                    <div className="app_input_group">
                      <InputField
                        placeholder="Enter School's Name"
                        name="name"
                        height={50}
                        labelTitle="Name"
                        required={true}
                      />
                      <InputField
                        placeholder="Enter Email"
                        name="email"
                        type="email"
                        height={50}
                        labelTitle={
                          <>
                            Email <span className="required">*</span>
                          </>
                        }
                      />
                    </div>
                    <div className="app_input_group">
                      <InputField
                        placeholder="Enter Address"
                        name="address"
                        height={50}
                        labelTitle="Address"
                        required={true}
                      />
                      <InputField
                        placeholder="Enter Phone Number 1"
                        name="phone_number1"
                        height={50}
                        labelTitle="Phone Number 1"
                        required={true}
                      />
                    </div>
                    <div className="app_input_group">
                      <InputField
                        placeholder="Enter Phone Number 2"
                        name="phone_number2"
                        height={50}
                        labelTitle="Phone Number 2"
                        required={true}
                      />
                      <InputField
                        placeholder="Enter Country"
                        name="country"
                        height={50}
                        labelTitle="Country"
                        required={true}
                      />
                    </div>
                    <div className="app_input_group">
                      <SelectField
                        labelTitle="State of Residence"
                        placeholder="Select State of Residence"
                        name="state_of_residence"
                        options={NigeriaStatesAndLGA}
                        height={50}
                        required={true}
                        valueKey="title"
                        selectedOption={values.state_of_residence}
                        handleChangeFunc={handleStateOfResidenceChange(
                          setFieldValue,
                        )}
                      />
                      <SelectField
                        labelTitle="L.G.A of Residence"
                        required={true}
                        placeholder="Select L.G.A of Residence"
                        name="lga_of_residence"
                        options={selectedStateLGAResidence}
                        height={50}
                        valueKey="title"
                        selectedOption={values.lga_of_residence}
                        handleChangeFunc={handleChange}
                      />
                    </div>
                    <div className="app_input_group">
                      <SelectField
                        labelTitle="Government Approved"
                        required={true}
                        placeholder="Government Approved?"
                        name="govt_approved"
                        options={yesNo}
                        height={50}
                        valueKey="title"
                        selectedOption={values.govt_approved}
                        handleChangeFunc={handleChange}
                      />
                      <EmptyDiv />
                    </div>
                    <FormSubHeader title="Owner Details" />
                    <div className="app_input_group">
                      <InputField
                        placeholder="Enter Owner's Name"
                        name="owner_name"
                        height={50}
                        labelTitle="Owner's Name"
                        required={true}
                      />
                      <InputField
                        placeholder="Enter Owner's Address"
                        name="owner_address"
                        height={50}
                        labelTitle="Owner's Address"
                        required={true}
                      />
                    </div>
                    <div className="app_input_group">
                      <InputField
                        placeholder="Enter Owner's Phone Number"
                        name="owner_phone"
                        height={50}
                        labelTitle="Owner's Phone Number"
                        required={true}
                      />
                      <InputField
                        placeholder="Enter Owner's Email"
                        name="owner_email"
                        height={50}
                        type="email"
                        labelTitle="Owner's Email"
                        required={true}
                      />
                    </div>
                    <div className="app_input_group">
                      <SelectField
                        labelTitle="State of Origin"
                        required={true}
                        placeholder="Select State of Origin"
                        name="state_of_origin"
                        options={NigeriaStatesAndLGA}
                        height={50}
                        valueKey="title"
                        selectedOption={values.state_of_origin}
                        handleChangeFunc={handleStateOfOriginChange(
                          setFieldValue,
                        )}
                      />
                      <SelectField
                        labelTitle="L.G.A of Origin"
                        required={true}
                        placeholder="Select L.G.A of Origin"
                        name="lga_of_origin"
                        options={selectedStateLGA}
                        height={50}
                        valueKey="title"
                        selectedOption={values.lga_of_origin}
                        handleChangeFunc={handleChange}
                      />
                    </div>

                    <FormSubHeader title="Subscription" />
                    <div className="app_input_group">
                      <SelectField
                        labelTitle="Subscription Package"
                        placeholder="Select a Subscription Package"
                        name="subscription_package_id"
                        required={true}
                        options={subscriptionPackages}
                        height={50}
                        valueKey="_id"
                        selectedOption={values.subscription_package_id}
                        handleChangeFunc={handleChange}
                      />
                      <EmptyDiv />
                      <EmptyDiv />
                      <EmptyDiv />
                    </div>

                    <FormSubHeader title="Other Details" />
                    <div className="app_input_group">
                      <SelectField
                        labelTitle="Active"
                        placeholder="Activate this School?"
                        name="active"
                        required={true}
                        options={yesNo}
                        height={50}
                        valueKey="title"
                        selectedOption={values.active}
                        handleChangeFunc={handleChange}
                      />
                      <EmptyDiv />
                      <EmptyDiv />
                      <EmptyDiv />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ButtonIcon
                        height={45}
                        marginTop={5}
                        color="#ffffff"
                        backgroundColor={colors.primary}
                        width={300}
                        borderColor={colors.primary}
                        buttonText={schoolId ? "Update School" : "Add School"}
                        type="submit"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>
    </>
  );
};

export default AddUpdateSchool;
